<template>
	<div>
		<div class="chart_Title" style="width:100%;align-items: center;" :style = "{ background: 'url(' +commenUrl+ baseConfig.title?.textRgb + ') no-repeat',backgroundSize:'100%',display:baseConfig?.title?.textShow?'flex':'none', height: baseConfig.title?.Height + 'px'}">
			<div class="img-icon" :style = "{ width: baseConfig.title?.textWidth + 'px', height: baseConfig.title?.textHeight + 'px', marginLeft: baseConfig.title?.textLeft + 'px', marginRight: baseConfig.title?.textRight + 'px',display:baseConfig?.title?.textIcon?'block':'none'}">
				<img style="height:100%;width:100%" :src="commenUrl+baseConfig?.title?.textIcon" alt="">
			</div>
			<div style="flex:1" :style = "{ fontSize: baseConfig.title?.textSzie + 'px', color: baseConfig.title?.textColor,textAlign: baseConfig.title?.textAlign}">{{baseConfig?.title?.textTitle}}</div>
		</div>
		<div id="charWord" :style="{width:width+'px',height:height+'px','padding-left':baseConfig.left+'px','padding-top':baseConfig.top+'px'}" v-if="showChart">
			<svg style="background-color: transparent" :style="{width:widthS+'px',height:heightS+'px'}" :changeFlag = "changeFlag" :chartData = "chartData">
				<a class="fontA" v-for="(tag, index) in tags" :key="`tag-${index}`">
				<text
					:id="tag.id"
					:x="tag.x"
					:y="tag.y"
					:font-size="tag.status=='1'?activeFontSize:fontSize"
					:style="{fill:tag.status=='1'?activeColor:color,'font-weight': 'bold'}"
					:fill-opacity="(400 + tag.z) / 600"
					@mousemove="listenerMove($event)"
					@mouseout="listenerOut($event)"
					@click="clickToPage"
				>
					{{ tag.text,tag.x,tag.y }}
				</text>
				</a>
			</svg> 
		</div>
	</div>
</template>
  
<script setup>
import { ref,computed,watch,defineProps  } from 'vue';
import { useStore } from 'vuex';
const props = defineProps({
    index:{
        type:Number||String,
        default:0
    }
})
const store = useStore();
const showChart = ref(false)
// 获取缓存数据
const setProject = ref(computed(() => store.state.project));
const chartData = ref(computed(() => store.state.chartData));
const componentList = ref(computed(() => store.state.chartData.componentList));
const option = ref(componentList.value[props.index].config.options)
const baseConfig= ref(componentList.value[props.index].config.baseConfig) 
const dataChar = ref(componentList.value[props.index].data?.list) 
// 词云图配置
const tagsNum = ref(0) //标签数量
const speedX = ref(Math.PI / 340 / 1.5)//球一帧绕x轴旋转的角度
const speedY = ref(Math.PI / 340 / 1.5)//球一帧绕y轴旋转的角度
const tags = ref([])//
const timer = ref(null)
const changeFlag = ref(0)
const width = ref(0)//
const height = ref(0)//
const CX = ref(0)//球心x坐标
const CY = ref(0)//球心y坐标
const radius = ref(0)
const color = ref('#36dbff')
const activeColor = ref('red')
const fontSize = ref(10)
const activeFontSize = ref(14)
const widthS = ref(0)
const heightS = ref(0)
const initData = ()=> {
	showChart.value = false
	width.value = baseConfig.value.width
	height.value = baseConfig.value.height
	radius.value = option.value.radius
	widthS.value = radius.value*2*1.25
	heightS.value = radius.value*2*1.25
	CX.value = radius.value*1
	CY.value = radius.value*1.25

	color.value = option.value.color
	activeColor.value = option.value.activeColor
	fontSize.value = option.value.fontSize
	activeFontSize.value = option.value.activeFontSize
	//初始化标签位置
	tags.value = [];
	let data = dataChar.value||[]
	tagsNum.value = data.length;
	for (let i = 0; i < data.length; i++) {
		let tag = {};
		let k = -1 + (2 * (i + 1) - 1) / tagsNum.value;
		let a = Math.acos(k);
		let b = a * Math.sqrt(tagsNum.value * Math.PI); //计算标签相对于球心的角度
		tag.text = data[i].text;
		tag.status = data[i].status;
		tag.x = CX.value + radius.value * Math.sin(a) * Math.cos(b); //根据标签角度求出标签的x,y,z坐标
		tag.y = CY.value + radius.value * Math.sin(a) * Math.sin(b);
		tag.z = radius.value * Math.cos(a);
		tag.id = i; // 给标签添加id
		tags.value.push(tag);
	}
	showChart.value = true
}
// 纵向旋转
const rotateX = (angleX)=> {
	var cos = Math.cos(angleX);
	var sin = Math.sin(angleX);
	for (let tag of tags.value) {
		var y1 = (tag.y - CY.value) * cos - tag.z * sin + CY.value;
		var z1 = tag.z * cos + (tag.y - CY.value) * sin;
		tag.y = y1;
		tag.z = z1;
	}
}

// 横向旋转
const rotateY = (angleY)=> {
	var cos = Math.cos(angleY);
	var sin = Math.sin(angleY);
	for (let tag of tags.value) {
		var x1 = (tag.x - CX.value) * cos - tag.z * sin + CX.value;
		var z1 = tag.z * cos + (tag.x - CX.value) * sin;
		tag.x = x1;
		tag.z = z1;
	}
}
// 运动函数
const runTags =()=> {
	if (typeof timer.value === "number") {
		clearInterval(timer.value);
		timer.value = null;
	}
	let timers = setInterval(() => {
		rotateX(speedX.value);
		rotateY(speedY.value);
		
	// console.log(tags.value,'数据')
	}, 17);
	timer.value = timers;
}
// 监听移入事件
const listenerMove = (e)=> {
	if (e.target.id) {
		clearInterval(timer.value);
	}
}
// 监听移出事件
const listenerOut = (e)=> {
	if (e.target.id) {
		runTags();
	}
}
// 点击事件
const clickToPage = ()=> {}

initData()
runTags()

watch(() => store.state.chartData.componentList[props.index].config.options,(newVal, oldVal) => {
	//此时返回的是数组,按下标获取对应值
		if(newVal){
			initData()
			runTags()
		}
	},{ deep: true }
) 
watch(() => store.state.chartData.componentList[props.index].data,(newVal, oldVal) => {
	//此时返回的是数组,按下标获取对应值
		if(newVal){
			initData()
			runTags()
		}
	},{ deep: true }
)
watch(() => store.state.chartData.componentList[props.index].config.baseConfig,(newVal, oldVal) => {
	//此时返回的是数组,按下标获取对应值
		if(newVal){
			initData()
			runTags()
		}
	},{ deep: true }
)
</script>
<style scoped lang="less">
	#charWord{
		display: flex;
		align-items: center;
		position: relative;
		svg{
		}
	}
	.fontA {
		fill: #36dbff;
		font-weight: bold;
	}
	.fontA:hover {
		fill: #36dbff;
		cursor: pointer;
	}
	.fontZd {
		fill: red;
		font-weight: bold;
	}
	.fontZd:hover {
		fill: red;
		cursor: pointer;
	}
</style>